export default "__VITE_ASSET__B3QZkX5Y__"